import Utils from "../utils/utils"
import LogHelper from "../utils/logHelper"
import { v4 as uuidv4 } from 'uuid';

const utilsHelper = new Utils()

export default class DetectLogin{
    constructor(container_id, config, is_debug, storage_key) {
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.original_storage_key = storage_key
        this.storage_key = `${storage_key}_detect_login`
        this.uuid_storage_key = `${storage_key}_detect_login_uuid`
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
        this.retry_time = 3
    }

    run(current_url) {
        console.log('optimize99_run:', 'DetectLogin')
        console.log('current_url', current_url)

        let url = new URL(current_url)

        const platform = utilsHelper.checkPlatform()
        console.log('optimize99_run_DetectLogin:', platform)

        switch (platform) {
            case 'shopline':
                this.shopline(url.pathname)
                break;
            case 'cyberbiz':
                this.cyberbiz(url.pathname)
                break;
            case '91app':
                this.nineyi(url.pathname)
                break;
            default:
                console.log('optimize99_run_DetectLogin:', 'unknown')    
        }
    }

    async shopline(current_pathname){
        try {
            let that = this
            let activate_paths = [
                '/users/sign_up', '/users/sign_in', '/cart'
            ]
    
            if (activate_paths.includes(current_pathname) === false) {
                console.log('not_login_page:', current_pathname)
                let login_type = sessionStorage.getItem(this.storage_key)
                let uuid = sessionStorage.getItem(this.uuid_storage_key)
                if (!login_type) {
                    return
                }
                
                let main_config = null
                // 檢查是否登入
                if (!window.app) {
    
                    for (let idx = 0 ; idx <= this.retry_time; idx++) {
                        await utilsHelper.sleep(2000);
                        if (!window.app) {
                            continue
                        }
                        else {
                            break
                        }
                    }
                }

                if (!window.app) {
                    return
                }

                let config = window.app._invokeQueue.filter(function(param){
                    return param && param[2] && param[2][0] === 'mainConfig'
                })
                
                if (config.length !== 0) {
                    main_config = config[0]
                }

                if (main_config) {
                    if (main_config[2][1].currentUser) {
                        this.sendLoginEvent('success', login_type, uuid)
                        sessionStorage.removeItem(this.storage_key)
                        sessionStorage.removeItem(this.uuid_storage_key)
                    }
                }

                return
            }
    
    
            // 如果是登入頁才要做這些事
            console.log('login_page:', current_pathname)
    
            window.addEventListener('click', function(event) {
                try {
                    let target_ele = event.target
                    if (target_ele instanceof Element === false) {
                        if (target_ele.parentElement instanceof Element === false) {
                            return
                        }
                        else {
                            target_ele = target_ele.parentElement 
                        }
                    }
        
                    let closest_ele = null
                    let type = ''
                    if (current_pathname === '/users/sign_up' || current_pathname === '/users/sign_in') {
                        closest_ele = target_ele.closest('.chakra-button')
                    }
                    else {
                        closest_ele = target_ele.closest('.fb-login-btn-wrapper')
                    }
        
                    // console.log('target_ele',target_ele)
                    // console.log('closest_ele',closest_ele)
        
                    if (!closest_ele) {
                        return
                    }
                    if (current_pathname === '/users/sign_up' || current_pathname === '/users/sign_in') {
                        let btn = closest_ele.querySelector('svg')
                        let icon_type = btn.getAttribute('data-e2e-id')
                        if (icon_type.includes('line')) {
                            type = 'line'
                        }
                        else {
                            type = 'facebook'
                        }
        
                    }
                    else {
                        // 購物車頁面登入的按鈕只有facebook，我現在沒看過line的拉
                        type = 'facebook'
                    }
                    let uuid = ''
                    try {
                        uuid = utilsHelper.getClidByContainerId(that.original_storage_key)
                    } catch (error) {
                        uuid = uuidv4()
                        console.log('uuid:', uuid)
                    }
                    if (!uuid) {
                        uuid = uuidv4()
                    }
                    sessionStorage.setItem(that.uuid_storage_key, uuid)
                    sessionStorage.setItem(that.storage_key, type)
                    that.sendLoginEvent('count', type, uuid)
                } catch (error) {
                    that.logHelper.send({
                        "level": 'error',
                        "stage": 'detect_login_shopline_click',
                        'error_trace': {
                            error_message: error.message,
                            error_stack: error.stack,
                        }
                    })
                }
            })
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'detect_login_shopline',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    current_pathname: current_pathname,
                }
            })
        }
    }

    cyberbiz(current_pathname){
        try {
            let that = this
            let activate_paths = [
                '/account/signup', '/account/login', '/carts'
            ]
            console.log('optimze99_detectLogin:', 'cyberbiz')

            let is_activate = false
            for (let idx = 0; idx < activate_paths.length; idx++) {
                if (current_pathname.includes(activate_paths[idx]) === true) {
                    is_activate = true
                    break
                }
            }

            if (is_activate === false) {
                if (window.c12t && window.c12t.customer_id !== null) {
                    let login_type = sessionStorage.getItem(this.storage_key)
                    let uuid = sessionStorage.getItem(this.uuid_storage_key)
                    if (!login_type) {
                        return
                    }
                    this.sendLoginEvent('success', login_type, uuid)
                    sessionStorage.removeItem(this.storage_key)
                    sessionStorage.removeItem(this.uuid_storage_key)
                }
                return 
            }

            // 如果是登入頁才要做這些事
            console.log('login_page:', current_pathname)
            window.addEventListener('click', function(event) {
                try {
                    let target_ele = event.target
                    if (target_ele instanceof Element === false) {
                        if (target_ele.parentElement instanceof Element === false) {
                            return
                        }
                        else {
                            target_ele = target_ele.parentElement 
                        }
                    }
        
                    let closest_ele = null
                    let type = ''
                    // 購物車頁面
                    if (current_pathname.includes('carts')) {
                        // 找 btn classname
                        closest_ele = target_ele.closest('[class*="-login-button"]');
                    }
                    else {
                        // a classname
                        closest_ele = target_ele.closest('.third-party-btn')
                    }
        
                    // console.log('target_ele',target_ele)
                    // console.log('closest_ele',closest_ele)
        
                    if (!closest_ele) {
                        return
                    }

                    if (current_pathname.includes('carts')) {
                        if (closest_ele.className.includes('line')) {
                            type = 'line'
                        }
                        else if(closest_ele.className.includes('fb')) {
                            type = 'facebook'
                        }
                    }
                    else {
                        let link = closest_ele.querySelector('a')
                        let href = link.href
                        if (href.includes('facebook')) {
                            type = 'facebook'
                        }
                        else {
                            type = 'line'
                        }
                    }

                    let uuid = ''
                    try {
                        uuid = utilsHelper.getClidByContainerId(that.original_storage_key)
                    } catch (error) {
                        uuid = uuidv4()
                        console.log('uuid:', uuid)
                    }
                    if (!uuid) {
                        uuid = uuidv4()
                    }
                    sessionStorage.setItem(that.uuid_storage_key, uuid)
                    sessionStorage.setItem(that.storage_key, type)
                    that.sendLoginEvent('count', type, uuid)
                } catch (error) {
                    that.logHelper.send({
                        "level": 'error',
                        "stage": 'detect_login_cyberbiz_click',
                        'error_trace': {
                            error_message: error.message,
                            error_stack: error.stack,
                        }
                    })
                }
            })

        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'detect_login_cyberbiz',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    current_pathname: current_pathname,
                }
            })
        }
    }

    async nineyi(current_pathname){
        try {
            let that = this
            let activate_paths = [
                '/Login/Index',
            ]
            console.log('optimze99_detectLogin:', 'nineyi')

            let is_activate = false
            for (let idx = 0; idx < activate_paths.length; idx++) {
                if (current_pathname.includes(activate_paths[idx]) === true) {
                    is_activate = true
                    break
                }
            }

            if (is_activate === false) {
                
                var user = null
                for (let retry_idx = 0 ; retry_idx <= this.retry_time; retry_idx++) {
                    await utilsHelper.sleep(1000);
                    for (let idx = dataLayer.length - 1 ; idx > 0; idx --){
                        var param = dataLayer[idx]
                        //console.log(param)
                        if (param.event !== '91app.Pageview') {
                            continue;
                        }
                        
                        if (param['91app_PageView'] === undefined){
                            continue;
                        }
    
                        user = param['91app_PageView']
                        break;
                    }

                    if (user !== null) {
                        break
                    }
                    else {
                        continue
                    }
                }

                if (user === null) {
                    return
                }

                if (user.isLogin === false) {
                    return
                }

                let login_type = sessionStorage.getItem(this.storage_key)
                let uuid = sessionStorage.getItem(this.uuid_storage_key)
                if (!login_type) {
                    return
                }

                this.sendLoginEvent('success', login_type, uuid)
                sessionStorage.removeItem(this.storage_key)
                sessionStorage.removeItem(this.uuid_storage_key)

                return 
            }

            // 如果是登入頁才要做這些事
            console.log('login_page:', current_pathname)
            window.addEventListener('click', function(event) {
                try {
                    let target_ele = event.target
                    if (target_ele instanceof Element === false) {
                        if (target_ele.parentElement instanceof Element === false) {
                            return
                        }
                        else {
                            target_ele = target_ele.parentElement 
                        }
                    }
        
                    let closest_ele = null
                    let type = ''
                    closest_ele = target_ele.closest('[class*="LoginButton-"]');

                    if (!closest_ele) {
                        return
                    }

                    let class_name = closest_ele.className

                    if (class_name.includes('LINELoginButton')) {
                        type = 'line'
                    }
                    else if(class_name.includes('FACEBOOKLoginButton')) {
                        type = 'facebook'
                    }

                    let uuid = ''
                    try {
                        uuid = utilsHelper.getClidByContainerId(that.original_storage_key)
                    } catch (error) {
                        uuid = uuidv4()
                        console.log('uuid:', uuid)
                    }
                    if (!uuid) {
                        uuid = uuidv4()
                    }
                    sessionStorage.setItem(that.uuid_storage_key, uuid)
                    sessionStorage.setItem(that.storage_key, type)
                    that.sendLoginEvent('count', type, uuid)
                } catch (error) {
                    that.logHelper.send({
                        "level": 'error',
                        "stage": 'detect_login_nineyi_click',
                        'error_trace': {
                            error_message: error.message,
                            error_stack: error.stack,
                        }
                    })
                }
            })

        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'detect_login_nineyi',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    current_pathname: current_pathname,
                }
            })
        }
    }

    sendLoginEvent(event_type, login_type, uuid){

        try {

            let status = 0
            if (event_type !== 'count') {
                status = 1
            }
    
            let api_url = `/view/container/login?container=${this.container_id}&status=${status}&login_type=${login_type}&uuid=${uuid}`
    
            utilsHelper.callAPI(
                '', 
                'POST', 
                this.config.API_ENDPOINT + api_url, 
                null,
                true
            )
            this.logHelper.send({
                "level": 'info',
                "stage": 'detect_login_sendLoginEvent',
                "request_payload": status,
                "api_url": this.config.API_ENDPOINT + api_url, 
            })
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'detect_login_sendLoginEvent',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    event_type: event_type,
                    login_type: login_type
                }
            })
        }
        
        
    }

}